<template>
	<div style="background-color: white;padding: 10px;box-sizing: border-box;">
		<el-form ref="form" :model="form" label-width="80px" size="mini" v-if="configShow">
			<el-form-item label="万里牛编码">
				<el-input v-model="form.wlncode"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" style="float: right;" @click="onSubmit">保存</el-button>
			</el-form-item>
		</el-form>
	</div>

</template>
<style scoped>

</style>
<script>
	export default {
		props: {
			currentitem: {
				default: () => {
					return null
				}
			},
			emunid: {
				default: () => {
					return 0
				}
			},
		},
		data() {
			return {
				configShow: false,
				loading: false,
				form: {
					wlncode: null
				}
			}
		},
		watch: {
			emunid(e) {
				this.form.emunvalueid = e
				this.get()
			},
			currentitem(e) {
				if (e) {
					this.configShow = true
				} else {
					this.configShow = false
				}
			}
		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			get() {
				if (!this.emunid) {
					this.$message.error('请选择城市')
					return
				}
				this.loading = true
				this.$api.emunextend_city.get(this.emunid,{type:'code'}).then((res) => {
					this.loading = false
					if(res){
						this.form = res
					}else{
						this.form.wlncode = null
					}
					
				})
			},
			onSubmit() {
				if (!this.emunid) {
					this.$message.error('请选择城市')
					return
				}
				this.$api.emunextend_city.save('code',{data:this.form}).then(() => {
					this.$message.success('操作成功')
				})

			}
		},
		components: {


		}
	}
</script>
